const metaBuilders = new Map();

const metaKeyMap = {
  title: ['og:title'],
  type: ['og:type'],
  description: ['og:description'],
  image: ['og:image'],
  url: ['og:url'],
  site_name: ['og:site_name'],
};

const defaultMetaValues = {
  type: 'website',
  url: window.location.origin + window.location.pathname,
  site_name: 'The q1 Network',
  image: '/assets/images/q1-banner.png'
};


export function registerMetaBuilder(tagName, builder) {
  metaBuilders.set(tagName, (context) => ({
    ...defaultMetaValues,
    ...builder(context),
  }));
}

export function updateMetaTags(meta = {}) {
  const head = document.head;

  Object.entries(meta).forEach(([key, value]) => {
    if (!value) return;
    const metaNames = metaKeyMap[key] || [key];

    metaNames.forEach(name => {
      let tag = head.querySelector(`meta[property='${name}'], meta[name='${name}']`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(name.startsWith('og:') ? 'property' : 'name', name);
        head.appendChild(tag);
      }
      tag.setAttribute('content', value);
    });
  });
}

export function updateMetaFromContext(tagName, metaContext = {}) {
  const builder = metaBuilders.get(tagName);
  if (!builder) {
    console.warn(`No meta builder registered for tagName: ${tagName}`);
    return;
  }

  const tags = builder(metaContext);

  if (tags?.docTitle) {
    document.title = tags.docTitle;
  }

  updateMetaTags(tags);
}

export function setErrorMeta({ 
  title = 'Error - q1 Network', 
  description = 'Something went wrong.', 
  image = null, 
  url = window.location.href 
} = {}) {
  const meta = {
    docTitle: title,
    title,
    type: 'website',
    description,
    image,
    url,
    site_name: 'The q1 Network'
  };
  document.title = meta.docTitle;
  updateMetaTags(meta);
}
